export async function loadOpacityUpdater(engine, refresh = true) {
    await engine.addParticleUpdater("opacity", async (container) => {
        const { OpacityUpdater } = await import("./OpacityUpdater.js");
        return new OpacityUpdater(container);
    }, refresh);
}
